import type {
  Contest,
  ContestDetail,
  ContestListItem,
  ContestOptions,
  ContestPayload,
} from "@/types/contests";
import { apiClient } from "./client";

export const contestsApi = {
  getContests() {
    return apiClient.get<ContestListItem[]>("/api/contests");
  },

  getContest(id: string) {
    return apiClient.get<ContestDetail>(`/api/contests/${id}`);
  },

  getOptions() {
    return apiClient.get<ContestOptions>("/api/contests/options");
  },

  createContest(payload: ContestPayload) {
    return apiClient.post<Contest>("/api/contests", payload);
  },

  updateContest(id: string, payload: ContestPayload) {
    return apiClient.put<Contest>(`/api/contests/${id}`, payload);
  },

  activateContest(id: string) {
    return apiClient.post<Contest>(`/api/contests/${id}/activate`);
  },

  /** Ends the contest and freezes the ranking. */
  finishContest(id: string) {
    return apiClient.post<Contest>(`/api/contests/${id}/finish`);
  },

  deleteContest(id: string) {
    return apiClient.delete<void>(`/api/contests/${id}`);
  },
};
